/** Registration question-answer history API. */

import { getLicenseQuestionAnswerHistory } from "@/hera-api/client/sdk.gen";
import type { LicenseQuestionAnswerHistoryEventSchema } from "@/hera-api/client/types.gen";

export type QuestionAnswerHistoryEvent =
  LicenseQuestionAnswerHistoryEventSchema;

export interface QuestionAnswerHistoryResponse {
  events: QuestionAnswerHistoryEvent[];
  truncated: boolean;
}

export async function getQuestionAnswerHistory(
  licenseId: string,
): Promise<QuestionAnswerHistoryResponse> {
  const result = await getLicenseQuestionAnswerHistory({
    path: { license_id: licenseId },
  });

  if (result.error) {
    const error = result.error as { detail?: string; message?: string };
    throw new Error(
      error.detail ?? error.message ?? "Failed to load question answer history",
    );
  }

  return {
    events: result.data?.events ?? [],
    truncated: result.data?.truncated ?? false,
  };
}

export function questionAnswerHistoryActorLabel(
  event: Pick<QuestionAnswerHistoryEvent, "actor_name" | "actor_email">,
): string {
  if (event.actor_name && event.actor_email) {
    return `${event.actor_name} (${event.actor_email})`;
  }
  return event.actor_name ?? event.actor_email ?? "System";
}
